import { isText, mediaTypeOf } from "@rally/agreed";
import { endOf } from "./filing.ts";

export type TextPreview = "markdown" | "html" | "source" | null;

export function isPdfPreview(file: { name: string; mediaType: string }): boolean {
  return mediaTypeOf(file.mediaType, file.name) === "application/pdf" || endOf(file.name) === "pdf";
}

export function textPreviewFor(file: { name: string; mediaType: string }): TextPreview {
  const type = mediaTypeOf(file.mediaType, file.name);
  const end = endOf(file.name);

  if (type === "text/markdown" || end === "md" || end === "markdown") return "markdown";
  if (type === "text/html" || end === "html" || end === "htm") return "html";
  if (!isText(type)) return null;
  return "source";
}

export function linesIn(text: string): number {
  if (text.length === 0) return 0;
  const breaks = text.match(/\r\n|\r|\n/g)?.length ?? 0;
  return breaks + (/(?:\r\n|\r|\n)$/.test(text) ? 0 : 1);
}
